import React from 'react'
import { Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  theme => ({
    filter: {
      userSelect: 'none',
      cursor: 'pointer',
      marginTop: theme.spacing(1),
      padding: '6px 12px',
      borderRadius: theme.spacing(2),
      backgroundColor: theme.colors.filterBackground,
      marginRight: theme.spacing(1),
    },
    filterSelected: {
      backgroundColor: theme.colors.selectedOption,
    },
    filterText: {
      fontSize: '1.4rem',
      fontWeight: 400,
      color: theme.colors.tabLabel,
    },
    filterTextSelected: {
      color: theme.colors.primaryText,
    },
  }),
  { name: 'FilterButton' },
)

export interface FilterButtonProps {
  readonly className?: string
  readonly isSelected?: boolean
  readonly onClick?: () => void
  readonly text?: React.ReactNode
}

const FilterButton = ({
  className,
  isSelected,
  text,
  onClick,
}: FilterButtonProps) => {
  const classes = useStyles()
  return (
    <div
      className={classNames(
        className,
        classes.filter,
        isSelected && classes.filterSelected,
      )}
      onClick={onClick}
    >
      <Typography
        className={classNames(
          classes.filterText,
          isSelected && classes.filterTextSelected,
        )}
      >
        {text}
      </Typography>
    </div>
  )
}

export default FilterButton
